import React from "react";
import { DocumentLibrary } from "@/components/customer/DocumentLibrary";

export default function ServiceBulletins() {
  return (
    <DocumentLibrary
      overline="Knowledge Base"
      title="Service Bulletins"
      subtitle="Important service notices and updates issued by On The Move for your caravan's systems and components."
      docType="service_bulletin"
      emptyHint="Your OTM administrator can publish service bulletins here for customers to view."
    />
  );
}
